export const FILTER_GROUPS_QUERY_PARAM = 'filterGroups';
export const FILTERS_QUERY_PARAM = 'filters';
export const QUICK_FILTERS_PARAM = 'quickFilters';
export const COLUMNS_QUERY_PARAM = 'columns';
